import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getClientTickets } from '../../../../services/tickets/users';

export const ticketsQueryKeys = {
  all: ['tickets'],
  list: (params) => [...ticketsQueryKeys.all, 'list', params],
};

export function useTicketsQuery(params) {
  return useQuery({
    queryKey: ticketsQueryKeys.list(params),
    queryFn: () => getClientTickets(params),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
